export const BOOK_DEMO_URL =
  "https://calendly.com/lauren-logical/logical-health-intro-call";
export const CONTACT_EMAIL = "hello@logical.health";
